/** The Services list's client-side matching over the `GET /service-manager` snapshot. */

type ServiceFilterRow = Record<string, unknown>;

const text = (value: unknown) => (value === undefined || value === null ? '' : String(value));

/** Every field that has chosen values must hold one of them (case-insensitive); an `'all'` choice or none means no filter. */
export function matchesServiceFilters(
  row: ServiceFilterRow,
  chosen: Record<string, string[]>,
): boolean {
  return Object.entries(chosen).every(([field, values]) => {
    const wanted = values.map((value) => value.toLowerCase());
    if (!wanted.length || wanted.includes('all')) return true;
    return wanted.includes(text(row[field]).toLowerCase());
  });
}

const SEARCHED = ['name', 'serviceName', 'action', 'health', 'actionStatus', 'status'];

/** True when `needle` (any case) is in the service's name, service name, action, health, action status or status. */
export function matchesServiceSearch(row: ServiceFilterRow, needle: string): boolean {
  const lowered = needle.toLowerCase();
  return SEARCHED.some((field) => text(row[field]).toLowerCase().includes(lowered));
}
